import { Array } from 'stdlib/Array'

import type { TBrowser } from '../definitions'
import { CHROME_BROWSERS } from '../definitions'

/**
 * Chrome-t használ a user.
 * @param browser - Browser típusa.
 */
export default function isChrome (browser: TBrowser): boolean {
  return Array.includes(CHROME_BROWSERS, browser)
}
